import styled from 'styled-components'

import { SwipeLink } from '../../Carousel'
import { RetailBannerItems } from '../../RetailDashboard/contentful'

const BannerContainer = styled.div`
  position: relative;
`

const StyledBannerTextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
`

const StyledBannerTitle = styled.p`
  font-size: 3.75rem;
  font-family: var(--font-family-alpha), sans-serif;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0;
  color: white;
  text-align: center;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
`

const StyledBannerDescription = styled.p`
  font-size: 1.5rem;
  font-family: var(--font-family-alpha), sans-serif;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0;
  color: white;
  text-align: center;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
`

const StyledImage = styled.img`
  width: 100%;
  height: 336px;
  object-fit: cover;
  object-position: center;
  &.small-banner-image {
    height: 236px;
    border-radius: 8px;
  }
`

export const TestIds = {
  Description: 'Description',
} as const

export const RetailerBannerItem = ({
  linkUrl,
  imageUrl,
  title,
  showTitle,
  description,
  smallBannerImage = false,
}: RetailBannerItems) => (
  <SwipeLink href={linkUrl} key={`${linkUrl}-${title}`}>
    <BannerContainer>
      <StyledImage
        src={imageUrl}
        alt={title}
        loading="lazy"
        className={smallBannerImage ? 'small-banner-image' : ''}
      />
      <StyledBannerTextContainer>
        {showTitle && <StyledBannerTitle>{title}</StyledBannerTitle>}
        {Boolean(description) && (
          <StyledBannerDescription data-testid={TestIds.Description}>
            {description}
          </StyledBannerDescription>
        )}
      </StyledBannerTextContainer>
    </BannerContainer>
  </SwipeLink>
)
